// extracted by mini-css-extract-plugin
module.exports = {"module":"AlphanumericTaxCodeProfile_module__2e7Vg","content":"AlphanumericTaxCodeProfile_content__1c9_P"};